import { render, staticRenderFns } from "./DomainInput.vue?vue&type=template&id=2fd92933&scoped=true&"
import script from "./DomainInput.vue?vue&type=script&lang=js&"
export * from "./DomainInput.vue?vue&type=script&lang=js&"
import style0 from "./DomainInput.vue?vue&type=style&index=0&id=2fd92933&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd92933",
  null
  
)

export default component.exports